const validateReportFolio = (reportFolio: Record<string, string | number | boolean>) => {
    let error: Record<string, boolean> = {}
    let count: number = 0

    if (!reportFolio.maxFoliosAmount) {
        count += 1
        error = { ...error, maxFoliosAmount: true }
    }
    if (!reportFolio.maxRejectsAmount) {
        count += 1
        error = { ...error, maxRejectsAmount: true }
    }
    if (!!reportFolio.enableSurvey && !reportFolio.satisfactionQuestion) {
        count += 1
        error = { ...error, satisfactionQuestion: true }
    }

    return { count, error }
}

export { validateReportFolio }